module.exports = __webpack_public_path__ + "static/media/settings.0a5eb2e7.svg";